import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { get, has, orderBy } from 'lodash';
import moment from 'moment';
import { Link } from '@bd/bdcore-named-routes';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import PageSectionHeading from '../../PageSectionHeading';
// import BlogCategories from '../../components/BlogCategories';
import { colors } from '../../../styles';
// import BlogCategories from '../../BlogCategories';

const styles = css`
  .blogpost_wrapper {
    padding:45px 0;
    @media(min-width: 992px) {
      padding:90px 0;
      background-color: ${colors.whiteDarkest};
    }
  }
  .row {
    margin: 0;
  }
  .blogpost {
    display: block;
    position: relative;
    padding: 0 0 45px 0;
    width: 100%;
    max-width: 550px;
    @media(min-width: 768px) {
      width: 550px;
    }
    @media(min-width: 992px) {
      display: flex;
      flex-direction: column;
      background: ${colors.white};
      box-shadow: 0 15px 15px 0 rgba(0,0,0,0.15);
      margin: 20px 10px;
      min-height: 530px;
      transition: all .3s ease-out;
      width: 45%;
      max-width: 630px;
    }

    @media(min-width: 2000px) {
      width: 630px;
      margin: 20px;
    }
    &:hover {
      @media(min-width: 992px) {
        box-shadow: 0 15px 15px 0 rgba(0,0,0,0.25);
      }
    }
    .blogpost_image {
      width: 100%;
      margin: 0 0 15px 0;
      padding-top: 56.25%;
      background-size: cover;
      background-position: center center;
    }
    .blogpost_title {
      margin: 0 0 10px 0;
      font-weight: 700;
      font-size: 21px;
      color: ${colors.body};
      letter-spacing: 0.58px;
      line-height: 28px;
      @media(min-width: 992px) {
        font-size: 24px;
        letter-spacing: 0.67px;
        padding: 20px 60px 0 30px;
      }
    }
    .blogpost_date {
      font-weight: 700;
      font-size: 15px;
      color: ${colors.brand2};
      letter-spacing: 0.42px;
      line-height: 16px;
      padding: 0 30px 5px 0;
      @media(min-width: 992px) {
        padding: 0 30px 5px;
      }
    }
  }
  @media (min-width: 992px) {
    .blogpost {
      &:after {
        background-color: ${colors.brand1};
        width: 125px;
      }
      .blogpost_title {
        font-size: 23px;
      }
    }
  }
  .Blogposts_readWrapper {
    display: flex;
    justify-content: flex-end;
    padding: 0 60px 0 0;
    margin-top: -40px;
  }
  .Blogposts_readMore {
    background: ${colors.brand3};
    box-shadow: 0 15px 20px 0 rgba(0,0,0,0.20);
    height: 48px;
    width: 200px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 14px;
    color: ${colors.white};
    letter-spacing: 2px;
    text-align: center;
    text-transform: uppercase;
    border-radius: 5px;
    /* padding-right: 39px; */
    transition: all .3s ease-out;
    /* &::after {
      content: '';
      background-image: url('/images/arrow-right-white.svg');
      background-repeat: no-repeat;
      width: 19px;
      height: 15px;
      position: absolute;
      right: 20px;
      top: 50%;
      transition: all .3s ease-out;
      transform: translateY(-50%);
    } */
    &:hover {
      background-color: ${colors.brand3Darkest};
      &::after {
        right: 15px;
      }
    }
  }
  .Blogposts_btnWrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 30px 15px;
    flex-direction: column;
    align-items: center;
    @media(min-width: 992px) {
      padding: 50px 15px;
    }
  }
  .Blogposts_btn {
    background-color: ${colors.brand1};
    box-shadow: 0 9px 15px 0 rgba(0,0,0,0.15);
    border-radius: 9px;
    height: 60px;
    width: 265px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 14px;
    color: ${colors.white};
    letter-spacing: 2px;
    text-align: center;
    line-height: 14px;
    text-transform: uppercase;
    transition: all .3s ease-out;
    cursor: pointer;
    &:hover {
      background-color: ${colors.brand1Darkest};
    }
    &:focus {
      outline: none;
    }
  }
`;
const Increment = 6;
class BlogList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: Increment,
    };
  }
  showMore = () => {
    this.setState({ limit: this.state.limit + Increment });
  }
  render() {
    const { blogposts, content } = this.props;
    const { limit } = this.state;
    return (
      <div className={styles}>
        <div className="blogpost_wrapper">
          {
            get(content, '[0].section_heading') &&
            <PageSectionHeading h3={get(content, '[0].section_heading')} />
          }
          <div className="container">
            {/*
              <BlogCategories />
            */}
            <div className="row justify-content-md-center">
              {
                orderBy(blogposts, 'date', 'desc').slice(0, limit).map(post => (
                  <Link name="blogpost-detail" className="blogpost" params={{ blogpostTitle: post.title }} key={get(post, '_id')}>
                    <div className="blogpost_image order-lg-1 flex-fill" style={{ backgroundImage: `url(${buildThumbnailUrl(post.logo.contentUrl, { width: 800, height: 800 })})` }} />
                    <h3 className="blogpost_title">{get(post, 'title').slice(0, 70)}{get(post, 'title').length > 70 ? '...' : ''}</h3>
                    <h4 className="blogpost_date">
                      {
                        has(post, 'date') &&
                        moment(get(post, 'date')).format('MMMM D, YYYY')
                      }
                    </h4>
                    <div className="d-none d-lg-flex order-lg-2 Blogposts_readWrapper">
                      <span className="Blogposts_readMore">Read More</span>
                    </div>
                  </Link>
                ))
              }
            </div>
            {
              limit < blogposts.length &&
              <div className="Blogposts_btnWrapper">
                <button className="Blogposts_btn" onClick={this.showMore}>View The Next {Increment} Posts</button>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

BlogList.propTypes = {
  blogposts: PropTypes.arrayOf(PropTypes.object).isRequired,
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData(
  {
    blogposts: true,
  },
  {
    ifMissing404: true,
  },
)(BlogList);



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/BlogList.section.js